import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";

import ScrollTop from "@/components/ScrollTop";
import { AuthProvider } from "@/contexts/AuthContext";
import { UserDataProvider } from "@/contexts/UserDataContext";
import { store } from "@/main-store";
import Routes from "@/routes";
import ThemeCustomization from "@/themes";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The following are overriiding the default values because we already use firestore listeners for real-time updates.
      staleTime: 10 * 60 * 1000, // Cache data for 10 minutes
      refetchOnWindowFocus: false, // Avoid refetching unnecessarily
    },
  },
});

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ReduxProvider store={store}>
      <AuthProvider>
        <UserDataProvider>
          <Router>
            <ThemeCustomization>
              <ScrollTop>
                <Routes />
              </ScrollTop>
            </ThemeCustomization>
          </Router>
        </UserDataProvider>
      </AuthProvider>
    </ReduxProvider>
  </QueryClientProvider>
);

export default App;
